import AvatarWithAuth from './AvatarWithAuth';

export default AvatarWithAuth;
